export const ulReset = {
  listStyle: "none",
  paddingLeft: 0,
  marginLeft: 0,
}

export const triangle = color => ({
  width: 0,
  height: 0,
  borderLeft: "4px solid transparent",
  borderRight: "4px solid transparent",
  borderBottom: "6px solid",
  borderBottomColor: color,
})
